import { formatDate } from './utils';

export const renderIfNotTask = (task, column) => {
  if (!task?.isTask) {
    return `<span class="vertical-center-dates">
            <span class="column-disabled">${formatDate(
              task[column.name]
            )}</span>
        </span>`;
  }
  return null;
};

export const renderContentEndDate = ({ classOdd, taskDate, hasItUnfitYup }) => `
    <div class="${classOdd}" data-cell-type="endDate">
        <span>
            ${formatDate(taskDate)}
            
            ${hasItUnfitYup || ''}
        </span>
    </div>
`;
